export enum RequestStatus {
    NewRequest = 1,
    FetchingPayroll = 2,
    ImportReady = 3,
    RequestFailed = 4,
    FetchFailed = 5,
    Expired = 6,
}

// The dry-run validation outcome of a fetch, tracked separately from RequestStatus. Mirrors the backend
// RequestValidationStatus.
export enum ValidationStatus {
    NotValidated = 0,
    Validating = 1,
    Passed = 2,
    Failed = 3,
    CouldNotComplete = 4,
}

export enum ImportSource {
    Unspecified = 0,
    BEE = 1,
    EE = 2,
    CDM = 3,
    WSPATR = 4,
    EE_GroupImport = 5,
    Excel = 6,
    Payroll = 7
}